import React                                         from 'react'
import ReactDOM                                      from 'react-dom';
import thunk                                         from 'redux-thunk';
import Root                                          from './Root';
import app                                           from './reducers';
import { createStore, applyMiddleware }              from 'redux'
import createLogger                                  from 'redux-logger';
import './css/App.css';

import injectTapEventPlugin from 'react-tap-event-plugin';

injectTapEventPlugin();

const middleware = [ thunk ];

if ('production' !== process.env.NODE_ENV)
{
    middleware.push(createLogger());
}

let store = createStore(app, applyMiddleware(...middleware));

ReactDOM.render(
    <Root store={store} />,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js